import keenIcFlagVi from 'assets/icons/Keens/Flags/220-vietnam.svg';
import keenIcFlagEn from 'assets/icons/Keens/Flags/226-united-states.svg';
// charge connector types
import chargeConnectorACConnector from 'assets/images/ChargeConnectorTypes/ac_connector.svg';
import chargeConnectorACPlug from 'assets/images/ChargeConnectorTypes/ac_plug.svg';
import chargeConnectorACSocket from 'assets/images/ChargeConnectorTypes/ac_socket.svg';
import chargeConnectorCCS1Connector from 'assets/images/ChargeConnectorTypes/ccs1_connector.svg';
import chargeConnectorCCS1Plug from 'assets/images/ChargeConnectorTypes/ccs1_plug.svg';
import chargeConnectorCCS1Socket from 'assets/images/ChargeConnectorTypes/ccs1_socket.svg';
import chargeConnectorCCS2Connector from 'assets/images/ChargeConnectorTypes/ccs2_connector.svg';
import chargeConnectorCCS2Plug from 'assets/images/ChargeConnectorTypes/ccs2_plug.svg';
import chargeConnectorCCS2Socket from 'assets/images/ChargeConnectorTypes/ccs2_socket.svg';
import chargeConnectorChademoConnector from 'assets/images/ChargeConnectorTypes/chademo_connector.svg';
import chargeConnectorChademoPlug from 'assets/images/ChargeConnectorTypes/chademo_plug.svg';
import chargeConnectorChademoSocket from 'assets/images/ChargeConnectorTypes/chademo_socket.svg';
import chargeConnectorGptConnector from 'assets/images/ChargeConnectorTypes/gpt_connector.svg';
import chargeConnectorGptPlug from 'assets/images/ChargeConnectorTypes/gpt_plug.svg';
import chargeConnectorGptSocket from 'assets/images/ChargeConnectorTypes/gpt_socket.svg';
import chargeConnectorJ1772Connector from 'assets/images/ChargeConnectorTypes/j1772_connector.svg';
import chargeConnectorJ1772Plug from 'assets/images/ChargeConnectorTypes/j1772_plug.svg';
import chargeConnectorJ1772Socket from 'assets/images/ChargeConnectorTypes/j1772_socket.svg';
import chargeConnectorMennekesConnector from 'assets/images/ChargeConnectorTypes/mennekes_connector.svg';
import chargeConnectorMennekesPlug from 'assets/images/ChargeConnectorTypes/mennekes_plug.svg';
import chargeConnectorMennekesSocket from 'assets/images/ChargeConnectorTypes/mennekes_socket.svg';
import chargeConnectorTeslaConnector from 'assets/images/ChargeConnectorTypes/tesla_connector.svg';
import chargeConnectorTeslaPlug from 'assets/images/ChargeConnectorTypes/tesla_plug.svg';
import chargeConnectorTeslaSocket from 'assets/images/ChargeConnectorTypes/tesla_socket.svg';

// dialog icons
import dialogAcceptAgency from 'assets/images/Dialogs/img_accept_agency.svg';
import dialogActiveAgency from 'assets/images/Dialogs/img_active_agency.svg';
import dialogActiveChargeConnector from 'assets/images/Dialogs/img_active_charge_connector.svg';
import dialogActiveCustomer from 'assets/images/Dialogs/img_active_customer.svg';
import dialogChangeCard from 'assets/images/Dialogs/img_change_card.svg';
import dialogChangePassword from 'assets/images/Dialogs/img_change_password.svg';
import dialogChangeStationCode from 'assets/images/Dialogs/img_change_station_code.svg';
import dialogDeletePoint from 'assets/images/Dialogs/img_delete_point.svg';
import dialogDeleteVehicle from 'assets/images/Dialogs/img_delete_vehicle.svg';
import dialogInfo from 'assets/images/Dialogs/img_dialog_info.svg';
import dialogLimitPower from 'assets/images/Dialogs/img_dialog_limit_power.svg';
import dialogRefresh from 'assets/images/Dialogs/img_dialog_refresh.svg';
import dialogRfidLock from 'assets/images/Dialogs/img_dialog_rfid_lock.svg';
import dialogRfidRestore from 'assets/images/Dialogs/img_dialog_rfid_restore.svg';
import dialogSetPoa from 'assets/images/Dialogs/img_dialog_set_poa.svg';
import dialogSignContract from 'assets/images/Dialogs/img_dialog_sign_contract.svg';
import dialogUnsetPoa from 'assets/images/Dialogs/img_dialog_unset_poa.svg';
import dialogUpdateOrder from 'assets/images/Dialogs/img_dialog_update_order.svg';
import dialogError from 'assets/images/Dialogs/img_error.svg';
import dialogHideStation from 'assets/images/Dialogs/img_hide_station.svg';
import dialogTopUp from 'assets/images/Dialogs/img_money.svg';
import dialogNotice from 'assets/images/Dialogs/img_notice.svg';
import dialogNoticeEmail from 'assets/images/Dialogs/img_notice_email.svg';
import dialogNoticeTriangular from 'assets/images/Dialogs/img_dialog_notice.svg';
import dialogProvideCard from 'assets/images/Dialogs/img_provide_card.svg';
import dialogReportChargePoint from 'assets/images/Dialogs/img_report_charge_point.svg';
import dialogRevokeCard from 'assets/images/Dialogs/img_revoke_card.svg';
import dialogSetKPI from 'assets/images/Dialogs/img_set_KPI_agency.svg';
import dialogSetDefaultKPI from 'assets/images/Dialogs/img_set_default_KPI.svg';
import dialogSignOut from 'assets/images/Dialogs/img_sign_out.svg';
import dialogStopAgency from 'assets/images/Dialogs/img_stop_agency.svg';
import dialogStopCharge from 'assets/images/Dialogs/img_stop_charge.svg';
import dialogStopWork from 'assets/images/Dialogs/img_stop_work.svg';
import dialogStopWorking from 'assets/images/Dialogs/img_stop_working.svg';
import dialogSuccess from 'assets/images/Dialogs/img_success.svg';
import dialogUnhideStation from 'assets/images/Dialogs/img_unhide_station.svg';
import dialogLock from 'assets/images/Dialogs/img_lock.svg';
import dialogSetDefault from 'assets/images/Dialogs/img_set_default.svg';
import dialogFeedback from 'assets/images/Dialogs/img_dialog_feedback.svg';
import dialogMovePoint from 'assets/images/Dialogs/img_dialog_move_point.svg';
import dialogSetChargingPrice from 'assets/images/Dialogs/img_set_charging_price.svg';
import dialogHideNotification from 'assets/images/Dialogs/img_hide_notification.svg';
import dialogTopUpSuccess from 'assets/images/Dialogs/img_money_success.svg';
import dialogTopUpFailed from 'assets/images/Dialogs/img_money_failed.svg';
import dialogReadAllNotification from 'assets/images/Dialogs/img_read_all_notification.svg';

// avatar
import avatarDefaultIcon from 'assets/icons/Avatar/ic_default_avatar.svg';
import icConnectorBusy from 'assets/icons/ChargeConnector/ic_connector_busy.svg';

// file types
import icFileTypeDOC from 'assets/icons/ic_file_type_doc.svg';
import icFileTypeDOCX from 'assets/icons/ic_file_type_docx.svg';
import icFileTypeJPG from 'assets/icons/ic_file_type_jpg.svg';
import icFileTypePDF from 'assets/icons/ic_file_type_pdf.svg';
import icFileTypePNG from 'assets/icons/ic_file_type_png.svg';
import icFileTypeUNKNOWN from 'assets/icons/ic_file_type_unknown.svg';
import icFileTypeXLS from 'assets/icons/ic_file_type_xls.svg';
import icFileTypeXLSX from 'assets/icons/ic_file_type_xlsx.svg';
import icFileTypeZIP from 'assets/icons/ic_file_type_zip.svg';

// evg
import bankIcon from 'assets/icons/EVG/Item/bank-icon.svg';
import evgLogo from 'assets/icons/EVG/Logo/evg_logo.svg';
import evgLogoAuth from 'assets/icons/EVG/Logo/evg_logo_auth.svg';
import evgLogoDark from 'assets/icons/EVG/Logo/evg_logo_dark.svg';
import toggleRight from 'assets/icons/EVG/toggle_right.svg';
import notificationAlertIcon from 'assets/icons/icon_notification_alert.svg';
import setColumnIcon from 'assets/icons/icon_set_column.svg';
import evgLogoActivateAccount from 'assets/icons/EVG/Logo/evg_logo_active_account.svg';
import icClockTimeLeft from 'assets/icons/EVG/Item/ic_clock_time_left.svg';
import icClockOvertime from 'assets/icons/EVG/Item/ic_clock_overtime.svg';
import icWallet from 'assets/icons/ic_wallet.svg';
import icLogoQR from 'assets/icons/ic_logo_qr.svg';
import icLogoMomo from 'assets/icons/ic_logo_momo.svg';
import icLogoVNPay from 'assets/icons/ic_logo_vnpay.svg';
import icLogoBank from 'assets/icons/ic_logo_bank.svg';
import icSpeaker from 'assets/icons/ic_speaker.svg';
import icLight from 'assets/icons/ic_light.svg';
import evgLogoMaintainerAuth from 'assets/icons/EVG/Logo/evg_logo_maintainer_auth.svg';

// dashboard
import icTotalDuration from 'assets/icons/ic_total_duration.svg';
import icTotalEnergy from 'assets/icons/ic_total_energy.svg';
import icTotalPower from 'assets/icons/ic_total_power.svg';
import icTotalTransactions from 'assets/icons/ic_total_transactions.svg';
import icExpectedRevenue from 'assets/icons/ic_expected_revenue.svg';

import icPinHidden from 'assets/icons/pin_station_hidden.svg';
import icPinMaintaining from 'assets/icons/pin_station_maintaining.svg';
import icPinNormal from 'assets/icons/pin_station_normal.svg';
import icPinPending from 'assets/icons/pin_station_pending.svg';
import icPinStopped from 'assets/icons/pin_station_stopped.svg';

// App resources: icons, images, fonts...
const AppResource = {
  // icons
  icons: {
    // quybka
    icTotalDuration,
    icTotalEnergy,
    icTotalPower,
    icTotalTransactions,
    icExpectedRevenue,

    // keens
    keens: {
      flagEn: keenIcFlagEn,
      flagVi: keenIcFlagVi,
    },

    // file types
    fileType: {
      icFileTypeDOC,
      icFileTypeDOCX,
      icFileTypeJPG,
      icFileTypePDF,
      icFileTypePNG,
      icFileTypeUNKNOWN,
      icFileTypeXLS,
      icFileTypeXLSX,
      icFileTypeZIP,
    },

    // avatar
    avatar: {
      default: avatarDefaultIcon,
      carDefault: require('assets/images/Avatar/img_default_car.jpg'),
    },

    // evg
    evg: {
      evgLogo: evgLogo,
      evgLogoDark: evgLogoDark,
      evgLogoAuth: evgLogoAuth,
      toggleRight: toggleRight,
      notificationAlertIcon: notificationAlertIcon,
      bankIcon: bankIcon,
      evgLogoActivateAccount: evgLogoActivateAccount,
      icClockTimeLeft: icClockTimeLeft,
      icClockOvertime: icClockOvertime,
      icWallet: icWallet,
      icLogoQR: icLogoQR,
      icLogoMomo: icLogoMomo,
      icLogoVNPay: icLogoVNPay,
      icLogoBank: icLogoBank,
      icSpeaker: icSpeaker,
      icLight: icLight,
      evgLogoMaintainerAuth: evgLogoMaintainerAuth,
    },

    icConnectorBusy,
    setColumnIcon,

    pin: {
      normal: icPinNormal,
      hidden: icPinHidden,
      maintaining: icPinMaintaining,
      pending: icPinPending,
      stopped: icPinStopped,
    },
  },

  // images
  images: {
    // keens
    keens: {
      bg1: require('assets/images/Keens/bg1.jpg'),
    },

    // charge connector types
    chargeConnectorTypes: {
      ccs1Socket: chargeConnectorCCS1Socket,
      ccs1Plug: chargeConnectorCCS1Plug,
      ccs1Connector: chargeConnectorCCS1Connector,
      ccs2Socket: chargeConnectorCCS2Socket,
      ccs2Plug: chargeConnectorCCS2Plug,
      ccs2Connector: chargeConnectorCCS2Connector,
      chademoSocket: chargeConnectorChademoSocket,
      chademoPlug: chargeConnectorChademoPlug,
      chademoConnector: chargeConnectorChademoConnector,
      gbtSocket: chargeConnectorGptSocket,
      gbtPlug: chargeConnectorGptPlug,
      gbtConnector: chargeConnectorGptConnector,
      j1772Socket: chargeConnectorJ1772Socket,
      j1772Plug: chargeConnectorJ1772Plug,
      j1772Connector: chargeConnectorJ1772Connector,
      mennekesSocket: chargeConnectorMennekesSocket,
      mennekesPlug: chargeConnectorMennekesPlug,
      mennekesConnector: chargeConnectorMennekesConnector,
      acSocket: chargeConnectorACSocket,
      acPlug: chargeConnectorACPlug,
      acConnector: chargeConnectorACConnector,
      teslaSocket: chargeConnectorTeslaSocket,
      teslaPlug: chargeConnectorTeslaPlug,
      teslaConnector: chargeConnectorTeslaConnector,
      vehicleDefault: require('assets/images/ChargeConnectorTypes/img_vehicle_default.png'),
      imgChargePointDefault: require('assets/images/ChargeConnectorTypes/img_charge_point_default.jpg'),
      imgChargeStationDefault: require('assets/images/ChargeConnectorTypes/img_charge_station_default.png'),
      imgChargeStationBgDefault: require('assets/images/ChargeConnectorTypes/img_charge_station_bg_default.png'),
      imgBrandLogoDefault: require('assets/images/ChargeConnectorTypes/img_brand_logo_default.png'),
    },

    investor: {
      imgWalletInfo: require('assets/images/Investor/img_wallet_info.svg').default,
      imgElectricityCommission: require('assets/images/Investor/img_electricity_commission.svg')
        .default,
    },

    // dialog icons
    dialogIcons: {
      dialogReportChargePoint,
      dialogStopCharge,
      dialogSignOut,
      dialogStopWorking,
      dialogHideStation,
      dialogUnhideStation,
      dialogActiveChargeConnector,
      dialogDeletePoint,
      dialogChangeStationCode,
      dialogDeleteVehicle,
      dialogChangeCard,
      dialogProvideCard,
      dialogRevokeCard,
      dialogChangePassword,
      dialogSuccess,
      dialogError,
      dialogTopUp,
      dialogStopWork,
      dialogAcceptAgency,
      dialogActiveAgency,
      dialogStopAgency,
      dialogActiveCustomer,
      dialogSetKPI,
      dialogSetDefaultKPI,
      dialogSignContract,
      dialogUpdateOrder,
      dialogInfo,
      dialogRefresh,
      dialogLimitPower,
      dialogRfidLock,
      dialogRfidRestore,
      dialogNoticeEmail,
      dialogNoticeTriangular,
      dialogNotice,
      dialogSetPoa,
      dialogUnsetPoa,
      dialogLock,
      dialogSetDefault,
      dialogFeedback,
      dialogMovePoint,
      dialogSetChargingPrice,
      dialogHideNotification,
      dialogTopUpSuccess,
      dialogTopUpFailed,
      dialogReadAllNotification
    },

    // evg
    evg: {
      vehicleBg: require('assets/images/EVG/vehicle_bg.png'),
      bgSideBar: require('assets/images/EVG/bg_sidebar.png'),
      bgAuthForm: require('assets/images/EVG/bg_auth_form.png'),
      motorBg: require('assets/images/EVG/motor_bg.png'),
      connectorCharging: require('assets/images/EVG/img_connector_charging.png'),
      imgSlide1: require('assets/images/EVG/img_slide_1.jpg'),
      imgSlide2: require('assets/images/EVG/img_slide_2.jpg'),
      imgSlide3: require('assets/images/EVG/img_slide_3.jpg'),
      transactionStatusFinished: require('assets/images/EVG/transaction_status_finished.png'),
      transactionStatusCancelled: require('assets/images/EVG/transaction_status_cancelled.png'),
      frontIdCard: require('assets/images/EVG/front_id_card.png'),
      backIdCard: require('assets/images/EVG/back_id_card.png'),
      bgPassport: require('assets/images/EVG/bg_passport.png'),
      bgBusinessLicense: require('assets/images/EVG/bg_business_license.png'),
      bgActivateAccountSuccess: require('assets/images/EVG/bg_activate_account_success.png'),
      activateAccountSuccessImg: require('assets/images/EVG/activate_account_success_img.png'),
      bgActivateAccountFailed: require('assets/images/EVG/bg_activate_account_failed.png'),
      activateAccountFailedImg: require('assets/images/EVG/activate_account_failed_img.png'),
      maintainerSignInBg: require('assets/images/EVG/maintainer_sign_in_bg.png'),
      maintainerSignUpBg: require('assets/images/EVG/maintainer_sign_up_bg.png'),
      maintainerForgetPasswordBg: require('assets/images/EVG/maintainer_forget_password_bg.png'),
      maintainerActivateSuccessBg: require('assets/images/EVG/maintainer_activate_success_bg.png'),
      maintainerActivateFailedBg: require('assets/images/EVG/maintainer_activate_failed_bg.png'),
      bgActivateMaintainerAccountFailedBg: require('assets/images/EVG/bg_activate_maintainer_account_failed.png'),
    },
  },
};

export default AppResource;
